import React, { useEffect, useState } from "react";

import BannerImage from "../../statics/img/banner-sample-03.jpg";
import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import Footer from "../../components/Footer";
import HorizontalThumbnailGrid from "../../components/HorizontalThumbnailGrid";
import Image from "../../components/Image";
import ListHeader from "../../components/ListHeader";
import Navbar from "../../components/Navbar";
import Ratio from "../../components/Ratio";
import Spacer from "../../components/Spacer";
import Spinner from "../../components/Spinner";
import SubscriptionSection from "../../components/SubscriptionSection";
import useArchivedSessions from "../../hooks/useArchivedSessions";

const Sessions = () => {
  const sessions = useArchivedSessions();
  const [isLoading, setIsLoading] = useState(true);

  // Remove loading flag
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="SessionsPage">
      <Navbar />

      <Ratio w={32} h={9}>
        <Image src={BannerImage} />
      </Ratio>

      <Container>
        <div className="mt-12">
          {isLoading && !sessions ? (
            <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
              <div className="flex items-center justify-center space-x-4">
                <span>
                  <Spinner />
                </span>{" "}
                <span>Loading...</span>
              </div>
            </div>
          ) : sessions && sessions.length ? (
            <div className="w-full">
              <ListHeader header="Archive" title="Video Sessions" />

              <div className="mt-4">
                <HorizontalThumbnailGrid items={sessions} />
              </div>
            </div>
          ) : (
            <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
              No sessions.
            </div>
          )}
        </div>
      </Container>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Sessions;
